/**
 * ErroDeTela — limite de erro que PRESERVA o menu e a barra superior (padrão A, item 8).
 *
 * Fica dentro da casca, em volta do conteúdo: uma exceção de render numa tela mostra a mensagem no lugar
 * dela, e o resto do sistema segue de pé (antes, no Meet, a árvore inteira ia embora, menu e cabeçalho
 * junto: "tela em branco é bug"). Zera sozinho quando a rota muda (`resetKey`).
 */
import { Component, type ErrorInfo, type ReactNode } from "react";
import type { RenderLinkShell } from "./tipos.js";

interface Props {
  children: ReactNode;
  /** Muda esta chave (o `pathname`) para zerar o erro ao navegar. */
  resetKey?: string;
  renderLink: RenderLinkShell;
  hrefInicio: string;
}
interface Estado { erro: Error | null; info: string | null }

export class ErroDeTela extends Component<Props, Estado> {
  state: Estado = { erro: null, info: null };

  static getDerivedStateFromError(erro: Error): Partial<Estado> {
    return { erro };
  }

  componentDidCatch(erro: Error, info: ErrorInfo): void {
    console.error("[ErroDeTela] a tela quebrou:", erro, info.componentStack);
    this.setState({ info: info.componentStack ?? null });
  }

  componentDidUpdate(anterior: Props): void {
    if (anterior.resetKey !== this.props.resetKey && this.state.erro) this.setState({ erro: null, info: null });
  }

  render(): ReactNode {
    if (!this.state.erro) return this.props.children;
    return (
      <div className="casca-aviso-tela casca-aviso-erro" role="alert">
        <h1 className="casca-aviso-titulo">Esta tela encontrou um erro</h1>
        <p>O restante do sistema continua funcionando: use o menu para abrir outra tela.</p>
        <p>
          {this.props.renderLink({ href: this.props.hrefInicio, className: "casca-acao", children: <>Ir para o início</> })}
          <button type="button" className="casca-acao-sec" onClick={() => this.setState({ erro: null, info: null })}>
            Tentar abrir de novo
          </button>
        </p>
        <details className="casca-aviso-detalhe">
          <summary>Detalhe técnico (envie ao suporte se persistir)</summary>
          <pre>{this.state.erro.name}: {this.state.erro.message}{this.state.info ? `\n\nComponente:${this.state.info}` : ""}</pre>
        </details>
      </div>
    );
  }
}
